export const INTERNAL_AFFILIATION_NAME = 'Tacticart';
export const EXTERNAL_GENERAL_ROLE = 'external_general';

const normalizeRole = (value) => String(value || '').trim().toLowerCase() || 'general';
const normalizeString = (value) => String(value == null ? '' : value).trim();

export const isInternalOnlyAdminRole = (role) => {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'admin' || normalizedRole === 'general';
};

export const isExternalOnlyAdminRole = (role) => normalizeRole(role) === EXTERNAL_GENERAL_ROLE;

export const resolveAdminAffiliationName = ({
  role,
  isExternalAccount = false,
  externalAffiliationName = '',
} = {}) => {
  const normalizedRole = normalizeRole(role);
  const normalizedExternalAffiliationName = normalizeString(externalAffiliationName);
  if (isInternalOnlyAdminRole(normalizedRole)) return INTERNAL_AFFILIATION_NAME;
  if (isExternalOnlyAdminRole(normalizedRole)) {
    return normalizedExternalAffiliationName || INTERNAL_AFFILIATION_NAME;
  }
  return isExternalAccount
    ? normalizedExternalAffiliationName || INTERNAL_AFFILIATION_NAME
    : INTERNAL_AFFILIATION_NAME;
};

export const formatAdminDisplayName = ({
  adminDisplayName = '',
  fullName = '',
  username = '',
  fallbackName = '管理者',
  role,
  isExternalAccount = false,
  externalAffiliationName = '',
  useAsciiParentheses = false,
} = {}) => {
  const preformatted = normalizeString(adminDisplayName);
  if (preformatted && !useAsciiParentheses) return preformatted;
  const baseName =
    normalizeString(fullName) ||
    normalizeString(username) ||
    normalizeString(fallbackName) ||
    '管理者';
  if (isInternalOnlyAdminRole(role) && !isExternalAccount) return baseName;
  const affiliationName = resolveAdminAffiliationName({
    role,
    isExternalAccount,
    externalAffiliationName,
  });
  return useAsciiParentheses
    ? `${baseName} (${affiliationName})`
    : `${baseName}（${affiliationName}）`;
};
